module.exports = __webpack_public_path__ + "img/bid-price.59a586d3.png";